// A heading followed by a short text listed inline
import styled from 'styled-components';

import { size } from '../layout/helpers';
import { theme } from '../layout/theme';

export const Headline = styled.div`
  font: inherit;
  font-size: 16px;

  ${theme.screens.Md} {
    font-size: 18px;

    &.large {
      font-size: 20px;
    }
  }
`;

export const ProductPageHeadline = styled(Headline)`
  margin-top: 0;
`;

export const Heading = styled.div`
  display: inline-block;
  font: inherit;
  font-weight: 600;
  margin: 0 ${size(1)} 0 0;
`;

export const Tail = styled.div`
  display: inline;
  font: inherit;
  font-weight: 300;
`;
